import { FC, useCallback, useContext, useMemo } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import set from 'lodash/set';

import { ObjectivesForm } from '@modules/Objectives/partials/ObjectivesForm/ObjectivesForm';
import { OnboardingWizardContext } from '@modules/Onboarding/contexts/OnboardingWizardContext/OnboardingWizardContext';


type Props = {
  onComplete: () => void;
};

export const ObjectivesStep: FC<Props> = (props) => {
  const { onComplete } = props;
  const { data, setData } = useContext(OnboardingWizardContext);

  const onObjectiveChange = useCallback((fieldPath: string, value: any) => {
    const updatedData = set({ ...data }, `preferences.${fieldPath}`, value);
    setData(updatedData);
  }, [data, setData]);

  const defaultValues = useMemo(() => {
    return {
      communicationObjective1: data?.preferences?.communicationObjective1 || '',
      communicationObjective2: data?.preferences?.communicationObjective2 || '',
      communicationObjective3: data?.preferences?.communicationObjective3 || '',
    };
  }, [data?.preferences]);

  return (
    <Box>
      <Stack gap={2}>
        <Typography variant="body2" textAlign="center" fontSize={12} color="text.secondary" mb={3}>Great start! Let's define your objectives.</Typography>
        <Typography variant="body1" textAlign="center" fontSize={30} fontWeight={600}>
          Welcome to StoryForge - Communication objectives (optional)
        </Typography>
        <Typography variant="body2" textAlign="center" color="text.secondary" fontSize={16}>
          Help us personalize your experience by sharing your communication goals, or skip ahead to start with a story.
        </Typography>
      </Stack>

      <ObjectivesForm
        defaultValues={defaultValues}
        onFieldChange={onObjectiveChange}
        onSubmitRequest={onComplete}
        slots={{
          footer: (formState) => (
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Button
                variant="outlined"
                startIcon={<ArrowBack/>}
                size="large"
                disabled
              >
                Back
              </Button>
              <Button
                variant="contained"
                type="submit"
                endIcon={<ArrowForward/>}
                size="large"
              >
                {formState.isDirty ? 'Continue to Values' : 'Skip to Values'}
              </Button>
            </Stack>
          ),
        }}
      />
    </Box>
  );
};
